"use strict";

/*
 * Ein- und Ausklappen - ohne Bootstrap-JavaScript.
 *
 * Am 2026-09-01 eingefuehrt. Bedient data-bs-toggle="collapse" mit
 * data-bs-target wie vorher. Gebraucht wird es an einer Stelle: der
 * navbar-toggler in Nav.html, also das Menue auf schmalen Bildschirmen.
 *
 * Das CSS macht es einfach:
 *
 *     .collapse:not(.show){display:none}
 *     .collapsing{height:0;overflow:hidden;transition:height .35s ease}
 *     .collapsing{transition:none}
 *
 * Die zweite Regel schaltet die Bewegung wieder ab. Eine Hoehenberechnung
 * waere hier also Aufwand ohne Wirkung - ein Klassenwechsel genuegt und
 * entspricht genau dem, was die Seite vorher getan hat.
 */

document.addEventListener("click", function (e) {
    var knopf = e.target.closest('[data-bs-toggle="collapse"][data-bs-target]');
    if (!knopf) {
        return;
    }

    e.preventDefault();

    var ziel = document.querySelector(knopf.getAttribute("data-bs-target"));
    if (!ziel) {
        return;
    }

    var offen = ziel.classList.toggle("show");

    // Bootstrap setzt .collapsed am Knopf, solange zugeklappt ist.
    knopf.classList.toggle("collapsed", !offen);
    knopf.setAttribute("aria-expanded", offen ? "true" : "false");
});
